import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { CartProvider } from './context/CartContext';
import { StoreProvider } from './context/StoreContext';
import { YarboCareModal } from './components/YarboCareModal';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { Category } from './pages/Category';
import { ProductDetail } from './pages/ProductDetail';
import { Compare } from './pages/Compare';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { CheckoutConfirmation } from './pages/CheckoutConfirmation';
import { Account } from './pages/Account';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
// Admin (dev only)
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminOrders } from './pages/admin/AdminOrders';
import { AdminCustomers } from './pages/admin/AdminCustomers';
import { AdminProducts } from './pages/admin/AdminProducts';
import { AdminDiscounts } from './pages/admin/AdminDiscounts';
import { AdminTemplates } from './pages/admin/AdminTemplates';
import { AdminSettings } from './pages/admin/AdminSettings';
const NotFound = () => <div className="min-h-[60vh] flex flex-col items-center justify-center p-8 text-center bg-gray-50" data-id="element-0">
    <h1 className="text-4xl font-extrabold text-yarbo-dark mb-3" data-id="element-1">404</h1>
    <p className="text-gray-500 max-w-md mb-6" data-id="element-2">
      The page you're looking for doesn't exist.
    </p>
    <a href="/" className="bg-yarbo-dark text-white font-bold px-6 py-3 rounded-lg hover:bg-black" data-id="element-3">
      Return Home
    </a>
  </div>;
export function App() {
  return <StoreProvider data-id="element-4">
      <CartProvider data-id="element-5">
        <BrowserRouter data-id="element-6">
          <Routes data-id="element-7">
            {/* Customer site */}
            <Route path="/" element={<Layout data-id="element-9" />} data-id="element-8">
              <Route index element={<Home data-id="element-11" />} data-id="element-10" />
              <Route path="shop" element={<Shop data-id="element-13" />} data-id="element-12" />
              <Route path="category/:slug" element={<Category data-id="element-15" />} data-id="element-14" />
              <Route path="product/:slug" element={<ProductDetail data-id="element-17" />} data-id="element-16" />
              <Route path="compare" element={<Compare data-id="element-19" />} data-id="element-18" />
              <Route path="cart" element={<Cart data-id="element-21" />} data-id="element-20" />
              <Route path="checkout" element={<Checkout data-id="element-23" />} data-id="element-22" />
              <Route path="checkout/confirmation" element={<CheckoutConfirmation data-id="element-25" />} data-id="element-24" />
              <Route path="account" element={<Account data-id="element-27" />} data-id="element-26" />
              <Route path="contact" element={<Contact data-id="element-29" />} data-id="element-28" />
              <Route path="faq" element={<FAQ data-id="element-31" />} data-id="element-30" />
              <Route path="*" element={<NotFound data-id="element-33" />} data-id="element-32" />
            </Route>

            {/* Admin (dev only — accessed via header gear icon) */}
            <Route path="/admin" element={<AdminLayout data-id="element-35" />} data-id="element-34">
              <Route index element={<AdminDashboard data-id="element-37" />} data-id="element-36" />
              <Route path="orders" element={<AdminOrders data-id="element-39" />} data-id="element-38" />
              <Route path="customers" element={<AdminCustomers data-id="element-41" />} data-id="element-40" />
              <Route path="products" element={<AdminProducts data-id="element-43" />} data-id="element-42" />
              <Route path="discounts" element={<AdminDiscounts data-id="element-45" />} data-id="element-44" />
              <Route path="templates" element={<AdminTemplates data-id="element-47" />} data-id="element-46" />
              <Route path="settings" element={<AdminSettings data-id="element-49" />} data-id="element-48" />
            </Route>
          </Routes>
          {/* Global YarboCare upsell modal — appears after eligible products are added to cart */}
          <YarboCareModal data-id="element-50" />
        </BrowserRouter>
      </CartProvider>
    </StoreProvider>;
}